/**
 * sl-728o.7.3: Moderation Tutorial Session
 *
 * 3 steps guiding the user through moderation mode.
 */
import type { useI18n } from '@affine/i18n';

import type { TutorialSession } from '../../types';

type I18n = ReturnType<typeof useI18n>;

export function createModerationSession(t: I18n): TutorialSession {
  return {
    id: 'tutorial:moderation',
    context: {
      targetAudience: 'all',
      category: 'basics',
    },
    steps: [
      {
        targetSelector: '[data-testid="detail-header-moderation-button"]',
        title: t['com.streamlain.streamlain.tutorial.moderation.step1.title'](),
        content:
          t['com.streamlain.streamlain.tutorial.moderation.step1.content'](),
        animation: 'pulse',
        trigger: { type: 'manual' },
        position: 'bottom',
      },
      {
        targetSelector: '[data-testid="detail-header-moderation-button"]',
        title: t['com.streamlain.streamlain.tutorial.moderation.step2.title'](),
        content:
          t['com.streamlain.streamlain.tutorial.moderation.step2.content'](),
        animation: 'highlight',
        trigger: { type: 'manual' },
        position: 'left',
      },
      {
        targetSelector: '[data-testid="detail-header-moderation-button"]',
        title: t['com.streamlain.streamlain.tutorial.moderation.step3.title'](),
        content:
          t['com.streamlain.streamlain.tutorial.moderation.step3.content'](),
        animation: 'none',
        trigger: { type: 'manual' },
        position: 'left',
      },
    ],
  };
}
